import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { createSelector } from 'reselect';
import { Checkbox } from 'rmwc';

import Content from '../../content-manager/content';
import { decrementPending, incrementPending, request } from '../../containers/actions';
import Dialog from '../../dialog/dialog';
import * as styles from '../../styles';
import { setSelectedItems } from '../tree/actions';
import Tree from '../tree';
import * as actions from './actions';
import tinyMCEConfig from '../../utilities/tinymce_config';
import CommentList from '../../social/comment';
import { host_v2 } from '../../utilities/requests';
import * as Cookies from 'js-cookie';

export default class QuestionDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        onUpdate: () => null,
        onClose: () => null,
    }

    initialState = {
        currentTab: 0,
        originalQuestion: {},
        question: {
            type: 1,
            content: '',
            answer: '',
            key: 0,
            note: '',
            marker_note: '',
            page: '',
            options: 4,
            score: 0,
            scoresSum: 0,
            required_time: 60,
            is_common: false,
            total_pages:null
        },
    }

    state = _.cloneDeep(this.initialState)

    subjectsTreeSelector = createSelector(
        [
            () => this.props.store.getIn(['materialsTree', 'selected']),
            () => this.props.store.getIn(['subjectsTree']),
        ],
        () => <Tree
            store={this.props.store.get('subjectsTree')}
            tree
            readonly
            resource='subject'
            itemLabel={subject => `${subject.parent_material} - ${subject.title}`}
            filter={{
                material: this.props.store.getIn(['materialsTree', 'selected']).keySeq().join(',') || -1,
            }}
            label={window.gettext('Subjects Tree')}
        />,
    )

    typesTreeSelector = createSelector(
        [
            () => this.props.store.getIn(['materialsTree', 'selected']),
            () => this.props.store.getIn(['typesTree']),
        ],
        () => <Tree
            store={this.props.store.get('typesTree')}
            readonly
            resource='question-type'
            multiSelection={false}
            combobox
            filter={{
                material: this.props.store.getIn(['materialsTree', 'selected']).keySeq().join(',') || -1,
            }}
            label={window.gettext('Type')}
        />,
    )

    gradesTreeSelector = createSelector(
        [
            () => this.props.store.getIn(['levelsTree', 'selected']),
            () => this.props.store.getIn(['gradesTree']),
        ],
        () => <Tree
            store={this.props.store.get('gradesTree')}
            readonly
            resource='grade'
            combobox
            itemLabel='title'
            filter={{
                level: this.props.store.getIn(['levelsTree', 'selected']).keySeq().join(',') || -1,
            }}
            label={window.gettext('Grade')}
        />,
    )

    componentDidMount() {
        const fixFocus = () => {
            let editor;
            if (window.tinymce) {
                if (this.state.currentTab === 1) {
                    editor = window.tinymce.get('question-dialog-content');
                }
                else if (this.state.currentTab === 2) {
                    editor = window.tinymce.get('question-dialog-answer');
                }
            }
            if (editor) {
                try {
                    editor.focus();
                    this.focusFixed = (this.focusFixed || 0) + 1;
                    if (this.focusFixed < 4) {
                        setTimeout(fixFocus, 400);
                    }
                }
                catch (exception) {
                    setTimeout(fixFocus, 400);
                }
            }
            else {
                setTimeout(fixFocus, 400);
            }
        };
        fixFocus();
        this.fetch.bind(this)();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.id !== this.props.id)
            this.fetch.bind(this)();
        if (prevState.question.id !== this.state.question.id && this.state.question.fake && this.state.currentTab !== 0)
            this.setState({ currentTab: 0 });
        if (prevState.question.answer !== this.state.question.answer) {
            const element = document.createElement('div');
            element.innerHTML = this.state.question.answer;
            const scoreItems = element.querySelectorAll('[data-score]');
            const scores = _.uniqBy(
                _.map(scoreItems, item => ({ score: Number(item.dataset.score), id: item.dataset.scoreId })),
                'id',
            );
            const scoresSum = _.reduce(scores, (sum, item) => sum + item.score, 0);
            this.setState(update(this.state, { question: { scoresSum: { $set: scoresSum } } }));
        }
        if (window.tinyMCE && prevState.question.options !== this.state.question.options) {
            if (window.tinyMCE.get('question-dialog-content'))
                window.tinyMCE.get('question-dialog-content').options = this.state.question.options;
            if (window.tinyMCE.get('question-dialog-answer'))
                window.tinyMCE.get('question-dialog-answer').options = this.state.question.options;
        }
    }

    setQuestion(question) {
        const element = document.createElement('div');
        element.innerHTML = question.answer;
        const scoreItems = element.querySelectorAll('[data-score]');
        const scores = _.uniqBy(
            _.map(scoreItems, item => ({ score: Number(item.dataset.score), id: item.dataset.scoreId })),
            'id',
        );
        const scoresSum = _.reduce(scores, (sum, item) => sum + item.score, 0);
        this.setState({
            question: {
                ...question,
                options: question.options || 4,
                score: scoresSum,
                scoresSum,
                is_common: question.is_common
            },
            originalQuestion: {
                ...question,
                options: question.options || 4,
                score: scoresSum,
                scoresSum,
                is_common: question.is_common
            },
        });
        this.context.store.dispatch([
            setSelectedItems(
                _.uniq(_.map(question.subjects, subject => subject.parent_material_id)),
                'material',
                this.props.store.getIn(['materialsTree', 'elementId']),
            ),
            setSelectedItems(
                _.map(question.subjects, 'id'),
                'subject',
                this.props.store.getIn(['subjectsTree', 'elementId']),
            ),
            setSelectedItems(
                _.map(question.labels, 'id'),
                'question-label',
                this.props.store.getIn(['labelsTree', 'elementId']),
            ),
            setSelectedItems(
                question.question_type ? [question.question_type.id] : [],
                'question-type',
                this.props.store.getIn(['typesTree', 'elementId']),
            ),
            setSelectedItems(
                question.level ? [question.level.id] : [],
                'question-level',
                this.props.store.getIn(['questionLevelsTree', 'elementId']),
            ),
            setSelectedItems(
                question.status ? [question.status] : [],
                'question-Status',
                this.props.store.getIn(['statusesTree', 'elementId']),
            ),
            setSelectedItems(
                _.uniq(_.map(question.grades, grade => grade.level.id)),
                'level',
                this.props.store.getIn(['levelsTree', 'elementId']),
            ),
            setSelectedItems(
                _.map(question.grades, 'id'),
                'grade',
                this.props.store.getIn(['gradesTree', 'elementId']),
            ),
        ]);
    }

    isModified() {
        const question = this.state.originalQuestion;
        return (
            !_.isEqual(this.state.question, question) ||
            !_.isEqual(
                this.props.store.getIn(['subjectsTree', 'selected']).keySeq().toArray().sort(),
                _.map(question.subjects, i => String(i.id)).sort(),
            ) ||
            !_.isEqual(
                this.props.store.getIn(['labelsTree', 'selected']).keySeq().toArray().sort(),
                _.map(question.labels, i => String(i.id)).sort(),
            ) ||
            String(this.props.store.getIn(['typesTree', 'selected']).keySeq().first()) != String((question.question_type || {}).id) ||
            String(this.props.store.getIn(['questionLevelsTree', 'selected']).keySeq().first()) != String((question.level || {}).id) ||
            !_.isEqual(
                this.props.store.getIn(['gradesTree', 'selected']).keySeq().toArray().sort(),
                _.map(question.grades, i => String(i.id)).sort(),
            ) ||
            String(this.props.store.getIn(['statusesTree', 'selected']).keySeq().first()) != String(question.status)
        );
    }

    async save() {
        try {
            let imgagesSrc = this.state.question.content.match(/src=\"([^\"]+)\"/g);
            await Promise.all(_.map(imgagesSrc,async (imgSrc) => {
                let src = imgSrc.slice(5, imgSrc.length - 1);
                if(!src.includes("http")){
                this.context.store.dispatch(incrementPending())
                   const response = await fetch(host_v2 + '/api/MediaApi/SaveImageInBucket', {
                        method: "POST",
                        body: JSON.stringify({ imageBase64: src }),
                        headers: {
                            "Authorization": Cookies.getJSON('mhelli-token').accessToken,
                            "Content-Type": "application/json"
                        }
                    });
                    const data = await response.json();
                    let editedContent = this.state.question.content.replace(imgSrc, `src='${data.result }'`);
                    this.setState(update(this.state , { question: { content: { $set: editedContent } } }));
                    this.context.store.dispatch(decrementPending());
                }
            }))
            const id = this.state.question.id;
            window.c1 = this.state.question.content;
            window.a1 = this.state.question.answer;
            const payload = {
                ...this.state.question,
                total_pages:(this.state.question.total_pages || '').persian().english(),
                subjects: this.props.store.getIn(['subjectsTree', 'selected']).keySeq().map(id => ({ id })),
                labels: this.props.store.getIn(['labelsTree', 'selected']).keySeq().map(id => ({ id })),
                question_type: this.props.store.getIn(['typesTree', 'selected']).size
                    ? { id: this.props.store.getIn(['typesTree', 'selected']).keySeq().first() }
                    : null,
                level: this.props.store.getIn(['questionLevelsTree', 'selected']).size
                    ? { id: this.props.store.getIn(['questionLevelsTree', 'selected']).keySeq().first() }
                    : null,
                grades: this.props.store.getIn(['gradesTree', 'selected']).keySeq().map(id => ({ id })),
                status: this.props.store.getIn(['statusesTree', 'selected']).size
                    ? this.props.store.getIn(['statusesTree', 'selected']).keySeq().first()
                    : null,
            };
            let response;
            if (id) {
                response = await this.context.store.dispatch(request({
                    path: `/question/${id}/`,
                    body: payload,
                    method: 'PATCH',
                    gzip: true
                }));
                console.log("response edit" , response);
                this.context.store.dispatch(actions.updateQuestion(response, this.props.elementId));
                this.props.onUpdate();
                this.setQuestion(response);
            }
            else {
                response = await this.context.store.dispatch(request({
                    path: '/question/',
                    body: payload,
                    method: 'POST',
                    gzip: true
                }));
                this.context.store.dispatch(actions.addQuestion(response, this.props.elementId));
                this.props.onUpdate();
                this.setQuestion(response);
            }
            window.c2 = response.content;
            window.a2 = response.answer;
            const t = document.createElement('div');
            t.innerHTML = response.content;
            if (t.innerText.replace(/\s*/g, '') === '')
                // alert('If you expect this question to have a content then it\'s lost, contact Mr.Hosseini!');
                t.innerHTML = response.answer;
            if (t.innerText.replace(/\s*/g, '') === '')
                // alert('If you expect this question to have an answer then it\'s lost, contact Mr.Hosseini!');
                t.remove();
            await this.setScore();
            this.setState({ saved: true });
            setTimeout(() => this.setState({ saved: undefined }), 2500);
            return response;
        }
        catch (exception) {
            this.setState({ saved: false });
            setTimeout(() => this.setState({ saved: undefined }), 2500);
            console.error(exception);
            this.context.store.dispatch(actions.setErrors(exception));
            return false;
        }
    }

    async fetch() {
        this.setState(this.initialState);
        if (!this.props.id || this.props.id === '0')
            return;
        let url = `/question/${this.props.id}/`;
        const response = await this.context.store.dispatch(request(url, undefined, undefined, undefined, undefined, undefined, true));
        this.setQuestion(response);
    }

    async confirm() {
        try {
            const id = this.state.question.id;
            const response = await this.context.store.dispatch(request({
                path: `/question/${id}/confirm/`,
                method: 'POST',
            }));
            this.context.store.dispatch(actions.updateQuestion(response, this.props.elementId));
            this.props.onUpdate();
            this.setQuestion(response);
            await this.setScore();
            return response;
        }
        catch (exception) {
            console.error(exception);
            this.context.store.dispatch(actions.setErrors(exception));
            return false;
        }
    }

    async reject() {
        try {
            const id = this.state.question.id;
            const response = await this.context.store.dispatch(request({
                path: `/question/${id}/reject/`,
                method: 'POST',
            }));
            this.context.store.dispatch(actions.updateQuestion(response, this.props.elementId));
            this.props.onUpdate();
            this.setQuestion(response);
            return response;
        }
        catch (exception) {
            console.error(exception);
            this.context.store.dispatch(actions.setErrors(exception));
            return false;
        }
    }

    async setScore() {
        try {
            var url = window.location.pathname;
            if (url.includes('examinations')) {
                var urlArray = url.split('/');
                var examinationId = parseInt(urlArray[2]);
                var questionId = parseInt(urlArray[4]);
                const element = document.createElement('div');
                element.innerHTML = this.state.question.answer;
                const scoreItems = element.querySelectorAll('[data-score]');
                const scores = _.uniqBy(
                    _.map(scoreItems, item => ({ score: Number(item.dataset.score), id: item.dataset.scoreId })),
                    'id',
                );
                var response = await this.context.store.dispatch(request({
                    path: `/examquestion_scoreset/`,
                    body: {
                        examinationId: examinationId,
                        questionId: questionId,
                        scores: scores
                    },
                }));
            }
        }
        catch (e) {

        }
    }

    render() {
        // console.log(this.state.question.content)
        if (!this.props.id)
            return null;
        return <Dialog
            easyCancel={false}
            isOpen
            top='1em'>
            <div style={{ width: '18.4cm' }}>
                <div
                    style={{
                        display: this.state.currentTab === 0
                            ? undefined
                            : 'none',
                        marginTop: '-1.5em',
                    }}>
                    <div style={{ width: '100%', float: 'right' }}>
                        <label htmlFor='type_multiple_choice' style={{ marginLeft: '.5em' }}>
                            <input
                                id='type_multiple_choice'
                                type='radio'
                                checked={this.state.question.type === 1}
                                onChange={() => this.setState(update(this.state, { question: { type: { $set: 1 } } }))}
                            />
                            {window.gettext('Multiple Choice')}
                        </label>
                        <label htmlFor='type_essay' style={{ marginLeft: '.5em' }}>
                            <input
                                id='type_essay'
                                type='radio'
                                checked={this.state.question.type === 2}
                                onChange={() => this.setState(update(this.state, { question: { type: { $set: 2 } } }))}
                            />
                            {window.gettext('Essay Image')}
                        </label>
                        <label htmlFor='type_essay' style={{ marginLeft: '.5em' }}>
                            <input
                                id='type_essay_text'
                                type='radio'
                                checked={this.state.question.type === 3}
                                onChange={() => this.setState(update(this.state, { question: { type: { $set: 3 } } }))}
                            />
                            {window.gettext('Essay Text')}
                        </label>
                        {
                            this.props.store.getIn(['materialsTree', 'selected']).keySeq().toArray().includes("13") ||
                                this.props.store.getIn(['materialsTree', 'selected']).keySeq().toArray().includes("14") ||
                                this.props.store.getIn(['materialsTree', 'selected']).keySeq().toArray().includes("15") ||
                                this.props.store.getIn(['materialsTree', 'selected']).keySeq().toArray().includes("18")
                                ?
                                <Checkbox
                                    checked={this.state.question.is_common}
                                    value={this.state.question.is_common}
                                    onChange={({ target: { checked } }) => this.setState(update(this.state, { question: { is_common: { $set: checked } } }))}>
                                    &nbsp;
                                    {window.gettext('سوال مشترک علوم باخه و حلی')}
                                </Checkbox>
                                : null
                        }
                    </div>
                    <div style={treeStyle}>
                        <Tree
                            store={this.props.store.get('materialsTree')}
                            readonly
                            resource='material'
                            combobox
                            label={window.gettext('Material')}
                        />
                        <div style={{ maxHeight: '20em', overflowY: 'auto', marginTop: '.5em' }}>
                            {this.subjectsTreeSelector(this.props.store)}
                        </div>
                    </div>
                    <div style={{ ...treeStyle, maxHeight: '25em', overflowY: 'auto' }}>
                        <Tree
                            store={this.props.store.get('labelsTree')}
                            tree
                            readonly
                            resource='question-label'
                            label={window.gettext('Labels Tree')}
                        />
                    </div>
                    <div
                        style={{
                            ...treeStyle,
                            clear: 'right',
                            ...this.context.user.hasPerm('question.admin') ? { width: 'calc(100%/3 - .5rem)' } : {},
                        }}>
                        {this.typesTreeSelector(this.props.store)}
                    </div>
                    <div
                        style={{
                            ...treeStyle,
                            ...this.context.user.hasPerm('question.admin') ? { width: 'calc(100%/3 - .5rem)' } : {},
                        }}>
                        <Tree
                            store={this.props.store.get('questionLevelsTree')}
                            readonly
                            resource='question-level'
                            multiSelection={false}
                            combobox
                            label={window.gettext('Level')}
                        />
                    </div>
                    {this.context.user.hasPerm('question.admin')
                        ? <div
                            style={{
                                ...treeStyle,
                                width: 'calc(100%/3 - .5rem)',
                            }}>
                            <Tree
                                store={this.props.store.get('statusesTree')}
                                readonly
                                resource='question-Status'
                                multiSelection={false}
                                combobox
                                label={window.gettext('Status')}
                                staticItems={_.mapValues(
                                    _.mapKeys(Array(5), (__, index) => Number(index) + 1),
                                    (__, index) => ({ id: index, label: window.pgettext('question', 'question-Status-' + index) }),
                                )}
                            />
                        </div>
                        : null
                    }
                    <div style={{ ...treeStyle, clear: 'right' }}>
                        <Tree
                            store={this.props.store.get('levelsTree')}
                            resource='level'
                            combobox
                            label={window.pgettext('grade', 'Level')}
                        />
                    </div>
                    <div style={treeStyle}>
                        {this.gradesTreeSelector(this.props.store)}
                    </div>
                    <br style={{ clear: 'right' }} />
                    <br />
                    {this.state.question.type === 1
                        ? [
                            <div
                                key='options'
                                style={{
                                    float: 'right',
                                    clear: 'right',
                                    width: '100%',
                                }}>
                                <div style={{ clear: 'both' }}>
                                    {window.gettext('Correct Options')}:
                                    &nbsp;
                                    <span
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.setState(update(this.state, {
                                                question: { options: { $set: this.state.question.options + 1 } },
                                            }));
                                        }}>
                                        <i className='fa-plus'></i>
                                    </span>
                                    &nbsp;
                                    <span
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.setState(update(this.state, {
                                                question: { options: { $set: this.state.question.options - 1 } },
                                            }));
                                        }}>
                                        <i className='fa-minus'></i>
                                    </span>
                                </div>
                                {_.map(
                                    Array(this.state.question.options),
                                    (_, index) => <div
                                        style={{
                                            display: 'block',
                                            float: 'right',
                                            width: '25%',
                                        }}
                                        key={index}>
                                        <Checkbox
                                            ref={'key-' + index}
                                            checked={(this.state.question.key & 1 << index) > 0}
                                            onClick={() => {
                                                this.setState(
                                                    update(this.state, {
                                                        question: { key: { $set: this.state.question.key ^ 1 << index } },
                                                    }),
                                                    () => this.refs['key-' + index].mdcApi.checked = (this.state.question.key & 1 << index) > 0,
                                                );
                                            }}>
                                            {window.interpolate(
                                                window.gettext('Option %(index)s'),
                                                { index: (index + 1).persian() },
                                                true,
                                            )}
                                        </Checkbox>
                                    </div>,
                                )}
                            </div>,
                            <br key='1' style={{ clear: 'right' }} />,
                            <br key='2' />,
                        ]
                        : [
                            // <div
                            //     key='score'
                            //     style={{
                            //         float: 'right',
                            //         clear: 'right',
                            //         width: '50%',
                            //     }}>
                            //     {window.gettext('Point')}&nbsp;
                            //     <input
                            //         style={{
                            //             ...styles.field,
                            //             width: '8em',
                            //         }}
                            //         value={(this.state.question.score || '').persian(true)}
                            //         onChange={({ target: { value } }) => {
                            //             value = value.english(true);
                            //             if (isNaN(Number(value)))
                            //                 return;
                            //             this.setState(update(this.state, { question: { score: { $set: value } } }));
                            //         }}
                            //     />
                            // </div>,
                            <div
                                key='required_time'
                                style={{
                                    float: 'right',
                                    width: '50%',
                                }}>
                                {window.gettext('Mark Time')}&nbsp;
                                <input
                                    style={{
                                        ...styles.field,
                                        width: '8em',
                                    }}
                                    value={(this.state.question.required_time || '').persian(true)}
                                    onChange={({ target: { value } }) => {
                                        value = value.english(true);
                                        if (isNaN(Number(value)))
                                            return;
                                        this.setState(update(this.state, { question: { required_time: { $set: value } } }));
                                    }}
                                />
                                {window.gettext('Seconds')}
                            </div>,
                        ]
                    }
                    <div
                        key='score'
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: '50%',
                        }}>
                        {window.gettext('Point')}&nbsp;
                            <input
                                style={{
                                    ...styles.field,
                                    width: '8em',
                                }}
                                value={(this.state.question.score || '').persian(true)}
                                onChange={({ target: { value } }) => {
                                    value = value.english(true);
                                    if (isNaN(Number(value)))
                                        return;
                                    this.setState(update(this.state, { question: { score: { $set: value } } }));
                                }}
                            />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: '50%',
                        }}>
                        {window.gettext('From Page')}&nbsp;
                        <input
                            style={{
                                ...styles.field,
                                width: '8em',
                            }}
                            value={(this.state.question.page || '').split('-')[0].persian()}
                            onChange={
                                ({ target: { value } }) => {
                                    const pages =
                                        (this.state.question.page || '').split('-');
                                    pages[0] = value;
                                    this.setState(update(this.state, { question: { page: { $set: pages.join('-').persian() } } }));
                                }
                            } />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: '50%',
                        }}>
                        {window.gettext('To Page')}&nbsp;
                        <input
                            style={{
                                ...styles.field,
                                width: '8em',
                            }}
                            value={((this.state.question.page || '').split('-')[1] || '').persian()}
                            onChange={
                                ({ target: { value } }) => {
                                    const pages =
                                        (this.state.question.page || '').split('-');
                                    pages[1] = value;
                                    this.setState(update(this.state, { question: { page: { $set: pages.join('-').persian() } } }));
                                }
                            } />
                    </div>
                    <div
                        style={{
                            float: 'right',
                            width: '50%',
                        }}>
                        {window.gettext('تعداد صفحات')}&nbsp;
                        <input
                            style={{
                                ...styles.field,
                                width: '8em',
                            }}
                            value={(this.state.question.total_pages || '').persian()}
                            onChange={
                                ({ target: { value } }) => {
                                    this.setState(update(this.state, { question: { total_pages: { $set: value.persian() } } }));
                                }
                            } />
                    </div>
                    {this.state.question.type === 2
                        ? <div
                            style={{
                                float: 'right',
                                clear: 'right',
                                width: '100%',
                            }}>
                            {window.gettext('Marker Note')}:
                            <textarea
                                style={{
                                    ...styles.input,
                                    width: '100%',
                                    height: '5em',
                                }}
                                value={(this.state.question.marker_note || '').persian()}
                                onChange={
                                    ({ target: { value } }) =>
                                        this.setState(update(this.state, { question: { marker_note: { $set: value.persian() } } }))
                                }>
                            </textarea>
                        </div>
                        : null
                    }
                    <div
                        style={{
                            float: 'right',
                            clear: 'right',
                            width: '100%',
                        }}>
                        {window.gettext('Note')}:
                        <textarea
                            style={{
                                ...styles.input,
                                width: '100%',
                                height: '5em',
                            }}
                            value={this.state.question.note || ''}
                            onChange={
                                ({ target: { value } }) =>
                                    this.setState(update(this.state, { question: { note: { $set: value.persian() } } }))
                            }>
                        </textarea>
                    </div>
                </div>
                <div
                    style={{
                        display: this.state.currentTab === 1
                            ? undefined
                            : 'none',
                        marginTop: '-1em',
                    }}>
                    {this.state.question.type === 2
                        ? <div style={{ height: '1.7em' }}></div>
                        : null
                    }
                    <Content
                        style={{
                            width: '18.4cm',
                            display: 'block',
                            backgroundColor: 'white',
                        }}
                        id='question-dialog-content'
                        inline={false}
                        uploadImages={false}
                        embedImages
                        content={this.state.question.content}
                        titleLabel={window.gettext('Question Title')}
                        tinymceConfig={{
                            ...tinyMCEConfig,
                            toolbar: [
                                ...tinyMCEConfig.toolbar.slice(0, -1),
                                tinyMCEConfig.toolbar.slice(-1)[0] + ' question_styles',
                            ],
                        }}
                        onInit={editor => {
                            editor.getBody().style.margin = '2mm';
                            editor.getBody().style.width = 'calc(100% - 4mm)';
                            editor.options = this.state.question.options;
                        }}
                        onChange={content => {
                            if (content === this.state.question.content)
                                return;
                            this.setState(update(this.state, { question: { content: { $set: content } } }));
                        }}
                    />
                </div>
                <div
                    style={{
                        display: this.state.currentTab === 2
                            ? undefined
                            : 'none',
                        marginTop: '-1em',
                    }}>
                    {/* {this.state.question.type === 2
                        ?  */}
                        <div style={{ display: 'inline-block', width: '100%' }}>
                            <div
                                style={{
                                    clear: 'right',
                                    width: '50%',
                                    float: 'right',
                                    color: this.state.question.scoresSum === Number(this.state.question.score)
                                        ? styles.successColor
                                        : styles.fourthColor,
                                }}>
                                {window.gettext('Sum of scores')}: {this.state.question.scoresSum.persian()}
                            </div>
                            <div style={{ width: '50%', float: 'right' }}>
                                {window.gettext('Question score')}: {this.state.question.score.persian(true)}
                            </div>
                        </div>
                    {/*      : null
                     } */}
                    <Content
                        style={{
                            width: '18.4cm',
                            display: 'block',
                            backgroundColor: 'white',
                        }}
                        id='question-dialog-answer'
                        inline={false}
                        uploadImages={false}
                        embedImages
                        content={this.state.question.answer}
                        titleLabel={window.gettext('Question Title')}
                        stylesheets={this.state.question.type === 2 ? ['question'] : []}
                        tinymceConfig={{
                            ...tinyMCEConfig,
                            toolbar: [
                                ...tinyMCEConfig.toolbar.slice(0, -1),
                                tinyMCEConfig.toolbar.slice(-1)[0] + ' question_styles score',
                            ],
                            content_css: tinyMCEConfig.content_css + ',' + window.hashed_paths['css/question.css'],
                        }}
                        onChange={content => {
                            if (content === this.state.question.content)
                                return;
                            this.setState(update(this.state, { question: { answer: { $set: content } } }));
                        }}
                    />
                </div>
                <div
                    style={{
                        display: this.state.currentTab === 3
                            ? undefined
                            : 'none',
                        marginTop: '-1em',
                    }}>
                    <CommentList
                        target={['question', this.props.id, 'edit']}
                    />
                </div>
            </div>
            <div style={{ fontSize: '1rem' }}>
                <div style={{ display: this.state.question.fake ? 'none' : undefined, right: 0 }}>
                    <button
                        style={{
                            ...this.state.currentTab == 0
                                ? styles.activeTabButton
                                : styles.tabButton,
                            float: 'right',
                        }}
                        onClick={() => this.setState({ currentTab: 0 })}>
                        {window.gettext('Info')}
                    </button>
                    <button
                        style={{
                            ...this.state.currentTab == 1
                                ? styles.activeTabButton
                                : styles.tabButton,
                            float: 'right',
                        }}
                        onClick={() => {
                            this.setState({ currentTab: 1 });
                            if (window.tinymce.get('question-dialog-content'))
                                window.tinymce.get('question-dialog-content').focus();
                        }}>
                        {window.gettext('Question')}
                    </button>
                    <button
                        style={{
                            ...this.state.currentTab == 2
                                ? styles.activeTabButton
                                : styles.tabButton,
                            float: 'right',
                        }}
                        onClick={() => {
                            this.setState({ currentTab: 2 });
                            if (window.tinymce.get('question-dialog-answer'))
                                window.tinymce.get('question-dialog-answer').focus();
                        }}>
                        {window.gettext('Answer')}
                    </button>
                    <button
                        style={{
                            ...this.state.currentTab == 3
                                ? styles.activeTabButton
                                : styles.tabButton,
                            float: 'right',
                        }}
                        onClick={() => this.setState({ currentTab: 3 })}>
                        {window.gettext('Comment')}
                    </button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                    <button
                        key='close'
                        style={{ ...styles.button, minWidth: undefined, float: 'left', marginRight: '.5em' }}
                        onClick={() => {
                            if (this.isModified() && !window.confirm(window.gettext('Are you sure you wanna' +
                                ' cancel editing this question? Changes ' +
                                'will be lost')))
                                return;
                            this.props.onClose();
                        }}>
                        {window.gettext('Close')}
                    </button>
                    {this.isModified()
                        ? [
                            <button
                                key='save'
                                style={{
                                    ...styles.button,
                                    minWidth: undefined,
                                    float: 'left',
                                    marginRight: '.5em',
                                    ...this.state.saved === true
                                        ? {
                                            backgroundColor: styles.successBackColor,
                                        }
                                        : this.state.saved === false
                                            ? {
                                                backgroundColor: styles.alertBackColor,
                                            }
                                            : {
                                                backgroundColor: 'white',
                                                transition: 'background-color 3500ms',
                                            },
                                }}
                                onClick={async () => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna overwrite this question?')))
                                        return;
                                    const response = await this.save.bind(this)();
                                    if (!response)
                                        alert(window.gettext('Failed to save'));
                                }}>
                                {window.gettext('Apply')}
                            </button>,
                            <button
                                key='save_and_close'
                                style={{
                                    ...styles.defaultButton,
                                    minWidth: undefined,
                                    float: 'left',
                                    marginRight: '.5em',
                                }}
                                onClick={async () => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna overwrite this question?')))
                                        return;
                                    const response = await this.save.bind(this)();
                                    if (response) {
                                        this.props.onClose();
                                    }
                                    else {
                                        alert(window.gettext('Failed to save'));
                                    }
                                }}>
                                {window.gettext('Save')}
                            </button>,
                        ]
                        : null
                    }
                    {this.state.question.id
                        ? <button
                            key='confirm'
                            style={{
                                ...styles.defaultButton,
                                backgroundColor: styles.fourthColor,
                                minWidth: undefined,
                                float: 'left',
                                marginRight: '.5em',
                            }}
                            onClick={async () => {
                                if (!window.confirm(window.gettext('Are you sure you wanna save and confirm this question?')))
                                    return;
                                let response = await this.save.bind(this)();
                                response = response && await this.confirm.bind(this)();
                                if (response) {
                                    this.props.onClose();
                                }
                                else {
                                    alert(window.gettext('Failed to confirm'));
                                }
                            }}>
                            <i className='fa-check'></i>
                        </button>
                        : null
                    }
                </div>
            </div>
        </Dialog>;
    }
}

const treeStyle = {
    fontSize: '.8em',
    width: 'calc(50% - .5rem)',
    margin: '.25em',
    float: 'right',
};
